// extracted by mini-css-extract-plugin
export default {"overviewContainer":"Overview_overviewContainer__SBgd7","overviewSidebar":"Overview_overviewSidebar__-sIpu","overviewRoutesPage":"Overview_overviewRoutesPage__DtMVC"};